export enum Api {
    loginApi = "login.php",
    usersApi = "users.php",
    logApi = "log.php"
}